import { POLICY_RESET } from '@/store/types'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import PolicyRiskDetails from '@/components/core/underwriting/policy/PolicyRiskDetails.vue'

export const leavePolicy = {
  components: {
    PolicyRiskDetails
  },
  data() {
    return {
      routeTo: undefined,
      // Skip prompt to use internally only
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    genComponent() {
      return this.$refs.childComponent
    },
    riskComponent() {
      return this.$refs.childComponent.$refs.childComponent
    },
    doExit() {
      try {
        // AR: OS-660 Unlock Record upon exit 29-Jan-2021
        // add condition if no polno do not call unlock record
        if (this.policyInfo.polNo !== undefined) {
          this.unlockRecord(this.policyInfo.polNo, 'POL')
        }

        this.skipPrompt = true
        this.$store.commit(POLICY_RESET)
        this.$router.push(this.routeTo.path)
      } catch (e) { }
    },
    async doSaveAndExit() {
      // AR: OS-660 Unlock Record upon exit 29-Jan-2021
      // add condition if no polno do not call unlock record
      if (this.policyInfo.polNo !== undefined) {
        this.unlockRecord(this.policyInfo.polNo, 'POL')
      }
      // Emit saving event on global event bus
      // Each Policy page should listen to this and do partial Submit and save
      this.promptLeave = false
      // Policy General
      if (this.$store.state.underwriting.policy.policyLifeCycle === 1) {
        this.$refs.childComponent.doValidateAllWarn().then(result2 => {
          if (result2) {
            this.$refs.childComponent.$validator.validateAll().then(result => {
              if (result) {
                this.$refs.childComponent.policy.saving = true
                this.$refs.childComponent.doPolMasterSave().then(success => {
                  if (success) {
                    this.$refs.childComponent.policy.saving = false
                    try {
                      this.skipPrompt = true
                      this.$store.commit(POLICY_RESET)
                      this.$router.push(this.routeTo.path)
                    } catch (e) { }
                  }
                })
              } else {
                this.promptFieldCheck()
              }
            })
          }
        })
      } else if (this.$store.state.underwriting.policy.policyLifeCycle === 2) {
        this.genComponent().$refs.childComponent.doValidateAllWarn().then(result2 => {
          if (result2) {
            this.genComponent().$refs.childComponent.$validator.validateAll().then(result => {
              if (result) {
                this.genComponent().$refs.childComponent.policy.saving = true
                this.genComponent().$refs.childComponent.doPolMasterSave().then(success => {
                  if (success) {
                    if (this.policyHeaderTab === 2) {
                      this.genComponent().$refs.childComponent.doProceedOtherDetails().then(success2 => {
                        if (success2) {
                          this.genComponent().$refs.childComponent.policy.saving = false
                          try {
                            this.skipPrompt = true
                            this.$store.commit(POLICY_RESET)
                            this.$router.push(this.routeTo.path)
                          } catch (e) { }
                        } else {
                          this.genComponent().$refs.childComponent.policy.saving = false
                          this.$toast.error('An unexpected error occured while saving policy record.')
                        }
                      })
                    } else {
                      this.genComponent().$refs.childComponent.policy.saving = false
                      try {
                        this.skipPrompt = true
                        this.$store.commit(POLICY_RESET)
                        this.$router.push(this.routeTo.path)
                      } catch (e) { }
                    }
                  } else {
                    this.genComponent().$toast.error('An unexpected error occured while saving policy record.')
                    this.genComponent().$refs.childComponent.policy.saving = false
                  }
                })
              } else {
                this.promptFieldCheck()
                this.polTabs = this.headers
              }
            })
          }
        })
      } else if (this.$store.state.underwriting.policy.policyLifeCycle === 3) {
        if (this.policyRiskTab === 0) {
          this.riskComponent().policy.loading = true
          this.riskComponent().doPolRiskGrpSave().then((success) => {
            if (success) {
              this.riskComponent().policy.loading = false
              try {
                this.skipPrompt = true
                this.$store.commit(POLICY_RESET)
                this.$router.push(this.routeTo.path)
              } catch (e) { }
            } else {
              this.$toast.error('An unexpected error occured while saving risk group text.')
            }
            this.riskComponent().policy.loading = false
          })
        } else if (this.policyRiskTab === 1) {
          this.resetMessages()
          this.expandRiskDetails()
          this.$validator.validateAll().then((result3) => {
            if (result3) {
              if (this.riskComponent().busClsAppID === 'BD') {
                if (this.riskComponent().$refs.polBondRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polBondRisk.$validator.validateAll()
                    .then((result2) => {
                      if (this.riskComponent().$refs.polBondRisk.workerForm.wrkmanNo !== undefined) {
                        this.riskComponent()
                          .$refs.polBondRisk.$validator.validateAll('workerForm')
                          .then((result) => {
                            if (result) {
                              this.riskComponent().policy.loading = true
                              this.riskComponent().$refs.polBondRisk.workerForm.polNo = this.riskComponent().$refs.polBondRisk.mainForm.polNo
                              this.riskComponent().$refs.polBondRisk.workerForm.renCnt = this.riskComponent().$refs.polBondRisk.mainForm.renCnt
                              this.riskComponent().$refs.polBondRisk.workerForm.endtCnt = this.riskComponent().$refs.polBondRisk.mainForm.endtCnt
                              this.riskComponent().$refs.polBondRisk.workerForm.riskGrpNo = this.riskComponent().$refs.polBondRisk.mainForm.riskGrpNo
                              this.riskComponent().$refs.polBondRisk.workerForm.riskNo = this.riskComponent().$refs.polBondRisk.mainForm.riskNo
                              this.riskComponent()
                                .$refs.polBondRisk.doPolMiscWrkmanSave()
                                .then((success) => {
                                  if (success) {
                                    this.riskComponent().$refs.polBondRisk.initWorkerForm()
                                    this.riskComponent().$refs.polBondRisk.displayWorkerList()
                                    this.riskComponent()
                                      .$refs.polBondRisk.doPolMiscEmpytSave()
                                      .then((success2) => {
                                        if (success2) {
                                          this.riskComponent()
                                            .doMiscRiskSave()
                                            .then((success3) => {
                                              if (success3) {
                                                this.riskComponent().policy.loading = false
                                                try {
                                                  this.skipPrompt = true
                                                  this.$store.commit(POLICY_RESET)
                                                  this.$router.push(this.routeTo.path)
                                                } catch (e) { }
                                              } else {
                                                this.$toast.error(this.failedMessage('miscellaneous risk'))
                                                this.riskComponent().policy.loading = false
                                              }
                                            })
                                        } else {
                                          this.$toast.error(this.failedMessage('policy bond risk'))
                                          this.riskComponent().policy.loading = false
                                        }
                                      })
                                  } else {
                                    this.$toast.error(this.failedMessage('worker'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.promptFieldCheck()
                            }
                          })
                      } else if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polBondRisk.doPolMiscEmpytSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy bond risk'))
                              this.riskComponent().policy.loading = false
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'FI') {
                if (this.riskComponent().$refs.polFireRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polFireRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polFireRisk.doPolFireRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy fire risk'))
                              this.riskComponent().policy.loading = false
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'MO') {
                // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'MO') {
                if (this.riskComponent().$refs.polMtrRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polMtrRisk.$validator.validateAll()
                    .then((result2) => {
                      if (this.riskComponent().$refs.polMtrRisk.driverForm.seqNo !== undefined) {
                        this.riskComponent()
                          .$refs.polMtrRisk.$validator.validateAll('driverForm')
                          .then((result) => {
                            if (result) {
                              this.riskComponent().policy.loading = true
                              this.riskComponent().$refs.polMtrRisk.driverForm.polNo = this.riskComponent().$refs.polMtrRisk.mainForm.polNo
                              this.riskComponent().$refs.polMtrRisk.driverForm.renCnt = this.riskComponent().$refs.polMtrRisk.mainForm.renCnt
                              this.riskComponent().$refs.polMtrRisk.driverForm.endtCnt = this.riskComponent().$refs.polMtrRisk.mainForm.endtCnt
                              this.riskComponent().$refs.polMtrRisk.driverForm.riskGrpNo = this.riskComponent().$refs.polMtrRisk.mainForm.riskGrpNo
                              this.riskComponent().$refs.polMtrRisk.driverForm.riskNo = this.riskComponent().$refs.polMtrRisk.mainForm.riskNo
                              this.riskComponent()
                                .$refs.polMtrRisk.doPolMtrDrvSave()
                                .then((success) => {
                                  if (success) {
                                    this.riskComponent().$refs.polMtrRisk.initDriverForm()
                                    this.riskComponent().$refs.polMtrRisk.displayDriverList()
                                    this.riskComponent()
                                      .$refs.polMtrRisk.doPolMtrRiskSave()
                                      .then((success2) => {
                                        if (success2) {
                                          this.riskComponent()
                                            .doMiscRiskSave()
                                            .then((success3) => {
                                              if (success3) {
                                                this.riskComponent().policy.loading = false
                                                try {
                                                  this.skipPrompt = true
                                                  this.$store.commit(POLICY_RESET)
                                                  this.$router.push(this.routeTo.path)
                                                } catch (e) { }
                                              } else {
                                                this.$toast.error(this.failedMessage('miscellaneous risk'))
                                                this.riskComponent().policy.loading = false
                                              }
                                            })
                                        } else {
                                          this.$toast.error(this.failedMessage('policy motor risk'))
                                          this.riskComponent().policy.loading = false
                                        }
                                      })
                                  } else {
                                    this.$toast.error(this.failedMessage('named driver'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.promptFieldCheck()
                            }
                          })
                      } else if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polMtrRisk.doPolMtrRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy motor risk'))
                              this.riskComponent().policy.loading = false
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'HU') {
                // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'HU') {
                if (this.riskComponent().$refs.polHullRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polHullRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polHullRisk.doPolHullRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy hull risk'))
                              this.riskComponent().policy.loading = false
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                }
              } else if (this.riskComponent().busClsAppID === 'CA') {
                // else if (this.riskComponent().$refs.childComponent.busClsAppID === 'CA') {
                if (this.riskComponent().$refs.polCargoRisk) {
                  this.resetMessages()
                  this.riskComponent()
                    .$refs.polCargoRisk.$validator.validateAll()
                    .then((result) => {
                      if (result) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polCargoRisk.doPolCargoRiskSave()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .doMiscRiskSave()
                                .then((success3) => {
                                  if (success3) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage('miscellaneous risk'))
                                    this.riskComponent().policy.loading = false
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage('policy cargo risk'))
                              this.riskComponent().policy.loading = false
                            }
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                }
              } else {
                this.riskComponent()
                  .doMiscRiskSave()
                  .then((success3) => {
                    if (success3) {
                      this.riskComponent().policy.loading = false
                      try {
                        this.skipPrompt = true
                        this.$store.commit(POLICY_RESET)
                        this.$router.push(this.routeTo.path)
                      } catch (e) { }
                    } else {
                      this.$toast.error(this.failedMessage('miscellaneous risk'))
                      this.riskComponent().policy.loading = false
                    }
                  })
              }
            } else {
              this.promptFieldCheck()
            }
          })
        } else if (this.policyRiskTab === 2) {
          this.riskComponent().policy.saving = true
          this.resetMessages()
          this.riskComponent().doSaveItem()
          if (
            this.riskComponent().$refs.polItemUOM.mainForm.seqNo !== undefined &&
            this.riskComponent().$refs.polItemBen.mainForm.seqNo !== undefined
          ) {
            this.riskComponent().$refs.polItemUOM.policy.loading = true
            this.riskComponent()
              .$refs.polItemUOM.doPolItemUOMSave()
              .then((success) => {
                if (success) {
                  this.riskComponent().$refs.polItemUOM.doInitForm()
                  this.riskComponent().$refs.polItemUOM.getPolItemUOMList()
                  this.riskComponent().$refs.polItemBen.policy.loading = true
                  this.riskComponent()
                    .$refs.polItemBen.doPolItemBenSave()
                    .then((success2) => {
                      if (success2) {
                        this.riskComponent().$refs.polItemBen.doInitForm()
                        this.riskComponent().$refs.polItemBen.getPolItemBenList()
                        this.riskComponent().$refs.polItemBen.$emit('itemList')
                        if (this.riskComponent().$refs.polDiscLdg) {
                          this.riskComponent()
                            .$refs.polDiscLdg.$validator.validateAll()
                            .then((result2) => {
                              if (result2) {
                                this.riskComponent().policy.loading = true
                                this.riskComponent()
                                  .$refs.polDiscLdg.doSave()
                                  .then((success) => {
                                    if (success) {
                                      this.riskComponent()
                                        .$refs.polDiscLdg.doPolMasterSave()
                                        .then((success2) => {
                                          if (success2) {
                                            this.riskComponent().policy.loading = false
                                            try {
                                              this.skipPrompt = true
                                              this.$store.commit(POLICY_RESET)
                                              this.$router.push(this.routeTo.path)
                                            } catch (e) { }
                                          } else {
                                            this.$toast.error(this.failedMessage())
                                          }
                                        })
                                    } else {
                                      this.$toast.error(this.failedMessage())
                                    }
                                    this.riskComponent().policy.loading = false
                                    this.riskComponent().policy.saving = false
                                  })
                              } else {
                                this.promptFieldCheck()
                              }
                            })
                        } else {
                          this.riskComponent().policy.saving = false
                        }
                      } else {
                        this.$toast.error(this.failedMessage('policy item benefit'))
                      }
                      this.riskComponent().$refs.polItemBen.policy.loading = false
                    })
                } else {
                  this.$toast.error(this.failedMessage('policy SI'))
                }
                this.riskComponent().$refs.polItemUOM.policy.loading = false
              })
          } else if (this.riskComponent().$refs.polItemUOM.mainForm.seqNo !== undefined) {
            this.riskComponent().policy.saving = true
            this.riskComponent()
              .$refs.polItemUOM.doSaveUOM()
              .then(() => {
                if (this.riskComponent().$refs.polDiscLdg) {
                  this.riskComponent()
                    .$refs.polDiscLdg.$validator.validateAll()
                    .then((result2) => {
                      if (result2) {
                        this.riskComponent().policy.loading = true

                        this.riskComponent()
                          .$refs.polDiscLdg.doSaveDiscLdg()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .$refs.polDiscLdg.doPolMasterSave()
                                .then((success2) => {
                                  if (success2) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage())
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage())
                            }
                            this.riskComponent().policy.loading = false
                            this.riskComponent().policy.saving = false
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                } else {
                  this.riskComponent().policy.saving = false
                }
              })
          } else if (this.riskComponent().$refs.polItemBen.mainForm.seqNo !== undefined) {
            this.riskComponent().policy.saving = true
            this.riskComponent()
              .$refs.polItemBen.doSave()
              .then(() => {
                if (this.riskComponent().$refs.polDiscLdg) {
                  this.riskComponent()
                    .$refs.polDiscLdg.$validator.validateAll()
                    .then((result2) => {
                      if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polDiscLdg.doSaveDiscLdg()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .$refs.polDiscLdg.doPolMasterSave()
                                .then((success2) => {
                                  if (success2) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage())
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage())
                            }
                            this.riskComponent().policy.loading = false
                            this.riskComponent().policy.saving = false
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                } else {
                  this.riskComponent().policy.saving = false
                }
              })
          } else if (this.riskComponent().$refs.polDiscLdg) {
            this.riskComponent().policy.saving = true
            this.riskComponent()
              .$refs.polItemBen.doSave()
              .then(() => {
                if (this.riskComponent().$refs.polDiscLdg) {
                  this.riskComponent()
                    .$refs.polDiscLdg.$validator.validateAll()
                    .then((result2) => {
                      if (result2) {
                        this.riskComponent().policy.loading = true
                        this.riskComponent()
                          .$refs.polDiscLdg.doSaveDiscLdg()
                          .then((success) => {
                            if (success) {
                              this.riskComponent()
                                .$refs.polDiscLdg.doPolMasterSave()
                                .then((success2) => {
                                  if (success2) {
                                    this.riskComponent().policy.loading = false
                                    try {
                                      this.skipPrompt = true
                                      this.$store.commit(POLICY_RESET)
                                      this.$router.push(this.routeTo.path)
                                    } catch (e) { }
                                  } else {
                                    this.$toast.error(this.failedMessage())
                                  }
                                })
                            } else {
                              this.$toast.error(this.failedMessage())
                            }
                            this.riskComponent().policy.loading = false
                            this.riskComponent().policy.saving = false
                          })
                      } else {
                        this.promptFieldCheck()
                      }
                    })
                } else {
                  this.riskComponent().policy.saving = false
                }
              })
          }
        } else if (this.policyRiskTab === 3) {
          this.resetMessages()
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.riskComponent().policy.saving = true
              this.riskComponent()
                .saveRiskTrailer()
                .then((success) => {
                  if (success) {
                    this.riskComponent().policy.loading = false
                    try {
                      this.skipPrompt = true
                      this.$store.commit(POLICY_RESET)
                      this.$router.push(this.routeTo.path)
                    } catch (e) { }
                  } else {
                    this.$toast.error('Risk Trailer Save Failed')
                  }
                  this.riskComponent().saving = false
                })
            } else {
              this.promptFieldCheck()
            }
          })
        }
      } else if (this.$store.state.underwriting.policy.policyLifeCycle === 4) {
        this.riskComponent().$refs.additionalSettings.$validator.validateAll().then((result) => {
          if (result) {
            this.riskComponent().policy.saving = true
            this.riskComponent().saveRiskBeforeRelease = true
            this.riskComponent().doPolMasterSave().then((success) => {
              if (success) {
                this.$toast.success('Policy Summary has been Saved')
                this.riskComponent().policy.saving = false
                try {
                  this.skipPrompt = true
                  this.$store.commit(POLICY_RESET)
                  this.$router.push(this.routeTo.path)
                } catch (e) { }
              } else {
                this.policy.saving = false
                this.$toast.error(this.failedMessage())
              }
            })
          } else {
            this.promptFieldCheck()
          }
        })
      } else if (this.$store.state.underwriting.policy.policyLifeCycle === 5) {
        await this.genComponent().RISaveAndExit().then(async (success) => {
          if (success) {
            try {
              this.skipPrompt = true
              await this.$store.commit(POLICY_RESET)
              await this.$router.push(this.routeTo.path)
            } catch (e) { }
          }
        })
      } else {
        try {
          this.skipPrompt = true
          this.$store.commit(POLICY_RESET)
          this.$router.push(this.routeTo.path)
        } catch (e) { }
      }
    }
  },
  // If user tries to leave this page, it will prompt leave message
  beforeRouteLeave(to, from, next) {
    if (!this.skipPrompt && this.$store.state.underwriting.policy.promptWhenExit) {
      this.routeTo = to
      this.promptLeave = true
      next(false)
    } else {
      next()
    }
  },
  created() {
    this.$root.$on('leavePolicy', () => {
      this.doExit()
    })
    // AR: Initialize CommonUtil Menu 29-Jan-2021
    this.initCommonUtilMenu()
  },
  mixins: [
    recordLockMixin
  ],
  beforeDestroy() {
    this.$root.$off('leavePolicy')
  }
}
